<template>
  <div>
    <v-dialog v-model="showDialog" width="1200px" class="pa-0 ma-0">
      <v-card style="min-height: 60vh">
        <v-toolbar class="primary" dark
          >Relatório de despesas
          <v-spacer></v-spacer>
          <v-btn color="white" text @click="closeModal"> x </v-btn></v-toolbar
        >

        <v-card-text v-if="expenses?.length == 0 && !loading">
          <p>Nenhum dado disponível</p>
          <v-btn class="primary" @click="getData">Tentar novamente</v-btn>
        </v-card-text>

        <v-card-text v-else>
          <v-progress-circular
            v-show="loading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <br />
          <v-row>
            <v-spacer></v-spacer>
            <v-btn class="white" @click="exportToExcel()"
              ><v-icon color="green">mdi-microsoft-excel</v-icon
              ><v-icon color="green">mdi-download</v-icon></v-btn
            >
          </v-row>
          <br />
          <v-simple-table>
            <thead>
              <tr>
                <th class="subheading font-weight-light text-center">Item</th>
                <th class="subheading font-weight-light text-center">
                  Faturamento
                </th>
                <th class="subheading font-weight-light text-center">
                  Fechamento
                </th>
                <th class="subheading font-weight-light text-center">
                  Diferença
                </th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr v-for="(expense, index) in expenses" :key="index">
                <td>
                  <span>{{ expense.Item }} </span>
                </td>
                <td><span v-money-format="expense.Faturamento"></span></td>
                <td><span v-money-format="expense.Fechamento"></span></td>
                <td><span v-money-format="expense.Diferença"></span></td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import strapiApi from "../../../../libraries/strapi/strapiApi";
import { mapState } from "vuex";
import data_rp_fin417 from "../../../../libraries/data/data_rp_fin417";
import stmarieApi from "../../../../libraries/stmarie/stmarieApi";
import { read, utils, writeFile } from "xlsx";

export default {
  name: "dialog-expenses",
  props: ["value", "process"],
  components: {},

  data() {
    return {
      sortBy: "createdAt",
      sortDesc: true,
      search: null,
      page: 1,
      itemsPerPage: 50,
      serverItemsLength: 15,
      nfses: [],
      comments: [],
      newCommentValue: "",
      loading: false,
      expenses: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  async mounted() {},

  watch: {
    showDialog(val, oldVal) {
      if (val) {
        this.expenses = [];
        this.getData();
      }
    },
  },
  methods: {
    async exportToExcel() {
      let keys = ["Item", "Faturamento", "Fechamento", "Diferença"];

      let data = this.expenses.map((el) => {
        const sortedObj = {};
        keys.forEach((key) => {
          sortedObj[key] = el[key];
        });
        return sortedObj;
      });

      const ws = utils.json_to_sheet(data);

      const wb = utils.book_new();

      utils.book_append_sheet(wb, ws, "Relatório de despesas");

      writeFile(wb, "Relatório de despesas.xlsx");
    },

    closeModal() {
      this.showDialog = false;
    },

    async getData() {
      this.loading = true;

      if (this.process?.FIL_COD && this.process?.PRI_COD) {
        try {
          let values = await stmarieApi.rp_fin417(
            this.process?.FIL_COD,
            this.process?.PRI_COD
          );
          if (values?.length > 0) {
            this.expenses = values;
            let fieldsToAcc = ["Faturamento", "Fechamento", "Diferença"];
            let totals = {};

            for (let i = 0; i < fieldsToAcc.length; i++) {
              let field = fieldsToAcc[i];
              totals[field] = this.expenses.reduce(
                (acc, curr) => acc + curr[field],
                0
              );
            }
            this.expenses.push({ ...totals, Item: "Total" });
          } else {
            alert("Nenhum dado lido");
          }
        } catch (error) {
          alert(error);
        }
      } else {
        alert("Processo não selecionado");
      }

      this.loading = false;
    },
  },
};
</script>
